<template>
  <v-card>
    <v-container fluid>
      <v-row align="center" justify="end">
        <v-col cols="auto">
          <v-btn icon="mdi-plus" size="small" @click="addDialog = true"></v-btn>
        </v-col>
      </v-row>

      <v-row>
        <UsersTable />
      </v-row>
    </v-container>
  </v-card>

  <v-dialog v-model="addDialog" max-width="600">
    <v-card max-width="400" prepend-icon="mdi-package-variant-closed-plus" title="Ajouter un utilisateur">
      <v-card-text>
        <AddUserForm @finished="finished" />
      </v-card-text>
      <v-card-actions>
        <v-btn @click="addDialog = false">Annuler</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import UsersTable from './UsersTable.vue';
import AddUserForm from './forms/AddUserForm.vue';
import { Ref, ref } from 'vue';
import type { ComponentExposed } from 'vue-component-type-helpers';

const table: Ref<ComponentExposed<typeof UsersTable> | undefined> = ref();
const addDialog = ref(false);
const finished = async () => {
  if (table.value) {
    await table.value.refresh();
  }
  addDialog.value = false;
};
</script>

<style scoped></style>
